import Echo from 'laravel-echo';
import { buffers, END, eventChannel } from 'redux-saga'
import { call, put, take } from 'redux-saga/effects';
import cookieManager from './cookieManager';
import history from '../history';
import { APP_DEBUG, APP_URL, PUSHER_KEY } from '../env';
import { normalize } from '../services/helpers';
import { handleUpdateGame } from '../ActiveGame/sagas';
import { setOnline } from '../Presence';

/** A presence change, told apart from a game update on the same event channel. */
const PRESENCE = 'presence';

function registerChannels(gameId, userId) {
  return function* () {
    const echo = yield call(setupPusher);

    const channel = eventChannel(emitter => {

      function handleGameUpdate({ game: gameResponse }) {
        const game = normalize(gameResponse);

        emitter(game);
      }

      // if current user is not in game {
      // echo.private(`game.${gameId}`)
      //   .listen('GameUpdate', handleGameUpdate);
      // }

      echo.private(`game.${gameId}.user.${userId}`)
        .listen('GameUpdate', handleGameUpdate);

      // Who has the game open: the opponent's online dot.
      let here = [];
      const tell = () => emitter({ kind: PRESENCE, userIds: here.map(member => member.id) });
      echo.join(`game.${gameId}.presence`)
        .here((members) => { here = members; tell(); })
        .joining((member) => { here = [...here.filter(m => m.id !== member.id), member]; tell(); })
        .leaving((member) => { here = here.filter(m => m.id !== member.id); tell(); });

      const stop = history.listen(() => emitter(END));

      // Only this game's channels: the connection stays up for the player's own channel (Notices).
      return () => {
        stop();
        echo.leave(`game.${gameId}.user.${userId}`);
        echo.leave(`game.${gameId}.presence`);
      };
      // Kept while an update waits for a coin to land, not dropped.
    }, buffers.expanding());

    while (true) {
      const message = yield take(channel);
      if (message.kind === PRESENCE) {
        yield put(setOnline(gameId, message.userIds));
      } else {
        yield call(handleUpdateGame, message);
      }
    }
  };
}

/**
 * The one connection for the signed-in player, opened the first time something needs it and kept until they sign out
 * (closePusher). Each page leaves only its own channels.
 */
function setupPusher() {
  if (window.Echo) {
    return window.Echo;
  }

  const accessToken = cookieManager.getAccessToken();

  window.Pusher = require('pusher-js');

  window.Pusher.logToConsole = APP_DEBUG;

  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: PUSHER_KEY,
    cluster: 'us2',
    encrypted: true,
    logToConsole: APP_DEBUG,
    authEndpoint: `${APP_URL}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  });

  return window.Echo;
}

/** Signing out: the next player gets a connection with their own token. */
function closePusher() {
  if (window.Echo) {
    window.Echo.disconnect();
    window.Echo = null;
  }
}

export {
  closePusher,
  registerChannels,
  setupPusher,
};
